var map = {
	"./SpinPorteriaPortonovo_001.webp": 64387,
	"./SpinPorteriaPortonovo_002.webp": 21259,
	"./SpinPorteriaPortonovo_003.webp": 95624,
	"./SpinPorteriaPortonovo_004.webp": 56655,
	"./SpinPorteriaPortonovo_005.webp": 13621,
	"./SpinPorteriaPortonovo_006.webp": 32507,
	"./SpinPorteriaPortonovo_007.webp": 81007,
	"./SpinPorteriaPortonovo_008.webp": 31310,
	"./SpinPorteriaPortonovo_009.webp": 84493,
	"./SpinPorteriaPortonovo_010.webp": 36054,
	"./SpinPorteriaPortonovo_011.webp": 61872,
	"./SpinPorteriaPortonovo_012.webp": 40331,
	"./SpinPorteriaPortonovo_013.webp": 70513,
	"./SpinPorteriaPortonovo_014.webp": 87763,
	"./SpinPorteriaPortonovo_015.webp": 34217,
	"./SpinPorteriaPortonovo_016.webp": 53011,
	"./SpinPorteriaPortonovo_017.webp": 25796,
	"./SpinPorteriaPortonovo_018.webp": 16302,
	"./SpinPorteriaPortonovo_019.webp": 86114,
	"./SpinPorteriaPortonovo_020.webp": 48614,
	"./SpinPorteriaPortonovo_021.webp": 78549,
	"./SpinPorteriaPortonovo_022.webp": 96704,
	"./SpinPorteriaPortonovo_023.webp": 97980,
	"./SpinPorteriaPortonovo_024.webp": 44071,
	"./SpinPorteriaPortonovo_025.webp": 73621,
	"./SpinPorteriaPortonovo_026.webp": 60516,
	"./SpinPorteriaPortonovo_027.webp": 33567,
	"./SpinPorteriaPortonovo_028.webp": 5949,
	"./SpinPorteriaPortonovo_029.webp": 75850,
	"./SpinPorteriaPortonovo_030.webp": 92578,
	"./SpinPorteriaPortonovo_031.webp": 55330,
	"./SpinPorteriaPortonovo_032.webp": 60452,
	"./SpinPorteriaPortonovo_033.webp": 43725,
	"./SpinPorteriaPortonovo_034.webp": 35510,
	"./SpinPorteriaPortonovo_035.webp": 28776,
	"./SpinPorteriaPortonovo_036.webp": 32280
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41404;